class ShoppableProducts extends HTMLElement {
  constructor() {
    super();
    this.view_button = this.querySelector('.shoppable-products__button');
    
    this.view_button.addEventListener('click', () => {
      this.showProducts();
    });
    
    // When clicking outside of this component, hide the products
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target) && !this.view_button.contains(event.target)) {
        this.hideProducts();
      }
    });
  }
  
  showProducts() {
    const productsContainer = this.querySelector('.content__products');
    if (productsContainer) {
        productsContainer.classList.toggle('hidden');
        this.view_button.classList.toggle('open');
    }
  }
  hideProducts() {
    const productsContainer = this.querySelector('.content__products');
    if (productsContainer) {
        productsContainer.classList.add('hidden');
        this.view_button.classList.remove('open');
    }
  }
}

customElements.define('shoppable-products', ShoppableProducts);